// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeRange_root__oQS-L","bookingInfo":"TimeRange_bookingInfo__YCFqK","dateSection":"TimeRange_dateSection__2ETOw"};